<template>
         <!-- cookie弹窗 -->
    <div class="cookieRoot">
        <div class="addDialogBlock cookieDialogBlog" v-if="cookieDialog">
            <div class="title">(COOKIE POLICY)</div>
            <div class="addTagDialog contentBlock"   width="100%" >
                <div class="delContent" style="word-break: keep-all;  text-transform: uppercase;">we use cookies to enhance site navigation, analyze site usage, and assist in our marketing efforts. view our <a href="https://paperspotlight.com/paper-policy/privacyNotice.html" target="_blank"  style="color:#606266;text-decoration: underline;">privacy policy</a> for more details</div>
                <div slot="footer" class="dialog-footer">
                    <span class="confirmBtn " @click="handleCooie('ACCEPT')">ACCEPT ALL</span>
                    <span class="dellBtn"  @click="cookieDialog = false">DENY ALL</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const Base64 = require('js-base64').Base64
 export default {
    data() {
      return {
        cookieDialog: false,
      }
    },
     mounted() {
        let cookieStatus = localStorage.getItem('thesis-cookie')
        console.log('cookieStatus',cookieStatus)
        if(cookieStatus){
            const cookie = Base64.decode(cookieStatus).split('----');
            this.cookieDialog = cookie[1].replace(/\d{4}$/, '')?false:true
        }else{
             this.cookieDialog = true
        }
     },
     methods: {
        handleCooie(status){
            window.localStorage.setItem('thesis-cookie', Base64.encode(new Date().getTime() + '----' + status ))
            this.cookieDialog = false
        },
     }
 }
</script>


<style lang="scss" >  
.cookieRoot{
     .cookieDialogBlog{
            position: fixed;
            bottom: 0;
            right: 0;
            z-index: 999;
            width: 45%;
            min-width: 550px;
            max-width: 650px;
            border-radius: 8px !important;
            background: linear-gradient(to bottom, rgba(250, 250, 250, 0.9) 0%, rgba(250, 250, 250, 0.8) 40%, rgba(250, 250, 250, 0.6) 100%);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
            padding: 20px;
        
        .title{
            color: rgba(0, 0, 0, 0.9);
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            text-align: left;
            
        }
        .delContent{
            color: #606266;
            font-size: 14px;
        }
        .contentBlock{
            color: #606266;
            margin-top: 30px;
            display: flex;
            flex-direction: column;
            gap: 30px;
            .dialog-footer{
                display: flex;
                justify-content: flex-end;
                align-items: center;
                gap: 16px;
            }
        }
        .confirmBtn{
            cursor: pointer;
            display: flex;
            padding: 5px 16px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: var(--8, 8px);
            background: var(--Grey-Grey-900, #212121);
            color: var(--text-icon-font-wh-190-anti, hsla(0, 0%, 100%, .9));
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
        }
        .confirmBtn :hover{
                background: #424242;
        }
        .dellBtn{
            cursor: pointer;
            display: flex;
            padding: 5px 16px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: var(--8, 8px);
            color: #212121;
            border: 1px solid #212121;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }
        .dellBtn :hover{
                background: #dcdcdc;
        }

    }
}

@media screen and (max-width: 767px) {
    .cookieRoot{
        .cookieDialogBlog{
            position: fixed;
            bottom: 0;
            right: 0;
            z-index: 999;
            width: 100%;
            min-width: 100%;
            max-width: 100%;
            .title{
                font-size: 3.4vw !important;
                line-height: 2 !important;
            }
            .delContent{
                font-size: 3.2vw !important;
                line-height: 1.4 !important;
            }
            .confirmBtn{
                min-width: 20vw !important;
                font-size: 3.4vw !important;
                padding: 1.4vw !important;
                line-height: 1.4 !important;
            }
            .dellBtn{
                min-width: 20vw !important;
                font-size: 3.4vw !important;
                padding: 1.4vw !important;
                line-height: 1.4 !important;
            }
        }
    }

}
@media screen and (min-width: 767px) and (max-width: 1200px){
    .cookieRoot{
        .cookieDialogBlog{
            .title{
                font-size: 1.8vw !important;
                line-height: 2 !important;
            }
            .delContent{
                font-size: 1.4vw !important;
            }
            .confirmBtn{
                padding: .5vw 1.6vw !important;
                font-size: 1.4vw !important;
                line-height: 2.2vw !important;
            }
            .dellBtn{
                padding: .5vw 1.6vw !important;
                font-size: 1.4vw !important;
                line-height: calc( 2.2vw - 2px) !important;
            }
        }
    }
}
</style>


